export default "__VITE_ASSET__Dp719n2y__"